export default "<h4>Main Landing View</h4>\n<div>\n    <h3>A component</h3>\n</div>\n\n"